"use client";

import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { Menu, User as UserIcon } from "lucide-react";
import { useAuth } from "@/hooks/use-auth";
import Link from "next/link";
import { Button } from "./ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { Separator } from "./ui/separator";

export function SidePanel() {
  const { user, signOut } = useAuth();
  return (
    <Sheet>
      <SheetTrigger>
        <Menu />
      </SheetTrigger>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>Menu</SheetTitle>
        </SheetHeader>
        <div className="mt-4">
          {user ? (
            <div className="flex flex-col space-y-4">
              <div className="flex items-center space-x-4 px-4">
                <Avatar className="h-9 w-9">
                  {user.photoURL ? (
                    <AvatarImage
                      src={user.photoURL}
                      alt="User profile picture"
                    />
                  ) : null}
                  <AvatarFallback className="bg-primary text-primary-foreground">
                    {user?.isAnonymous ? "A" : <UserIcon />}
                  </AvatarFallback>
                </Avatar>
                <div className="flex flex-col space-y-1">
                  <p className="text-sm font-medium leading-none">
                    {user?.isAnonymous
                      ? "Anonymous User"
                      : user.displayName || "Guest"}
                  </p>
                  <p className="text-xs leading-none text-muted-foreground">
                    {user?.phoneNumber}
                  </p>
                </div>
              </div>
              <Separator />
              <div className="flex flex-col space-y-1 px-2">
                <Button variant="ghost" asChild className="justify-start">
                  <Link href="/profile">Profile</Link>
                </Button>
              </div>
              <Separator />
              <div className="px-2">
                <Button
                  variant="ghost"
                  onClick={signOut}
                  className="justify-start w-full"
                >
                  Log out
                </Button>
              </div>
            </div>
          ) : (
            <Button asChild className="w-full">
              <Link href="/login">Login</Link>
            </Button>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}